'use strict';

var StepResponsibilityDirective = function StepResponsibilityDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/step-responsibility.html'),
    controller: 'StepResponsibilityController',
    link: function link(scope, element) {
      scope.$on('scheduleChange:stepEntered', scope.stepEntered);
      element.find('.ag-fresh').addClass(scope.wizardShown);
    }
  };
};
StepResponsibilityDirective.$inject = [];
module.exports = StepResponsibilityDirective;